import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ICategory, IRoom } from '../model/room.model';
import {CategorySearchService} from '../service/category-search.service';



@Component({
    selector: 'jhi-category-auto-complete',
    templateUrl: './category-auto-complete.component.html',
    styles: []
})
export class CategoryAutoCompleteComponent implements OnInit {
    @Input() multiple: boolean;
    @Input() language: string;
    @Input() selectedCategories: any;
    @Input() filterByGroup: string;
    @Input() room: IRoom;
    filteredCategories: any[] = [];

    @Output() selectedCategoriesOutput: EventEmitter<any> = new EventEmitter<any>();
    @Output() unSelectedCategoriesOutput: EventEmitter<any> = new EventEmitter<any>();

    constructor(private categoryService: CategorySearchService) {}

    ngOnInit() {}

    filterCategory(event: any) {
        this.categoryService.search(event.query, this.room).subscribe((res: HttpResponse<ICategory[]>) => {
            const filtered: any[] = [];
            res.body.forEach((category, key, categorys) => {
                    filtered.push({ label: category.name, value: category });
                if (Object.is(categorys.length - 1, key)) {
                    this.filteredCategories = filtered;
                }
            });
        });
    }

    onSelectedCategory(event) {
        this.selectedCategoriesOutput.emit(event);
    }

    onUnselectedCategory(event) {
        this.unSelectedCategoriesOutput.emit(event);
    }
}
